module.exports = __webpack_public_path__ + "static/media/alert-white.84c399d8.svg";